import React from 'react'

import { AdditionalProperties } from './additional-properties'
import { EInvoiceData } from './e-invoice'
import { GeneralData } from './general'
import { Title } from './title'

export const Settings: React.FC = () => {
  return (
    <>
      <Title />
      <GeneralData />
      <AdditionalProperties />
      <EInvoiceData />
    </>
  )
}
